import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { removeToken } from "../../utils/auth";
import { subscribeSeatLocked } from "../../utils/seatLock";
import SeatLockedScreen from "./SeatLockedScreen";

// Mounted once, high in the tree (see App.js) so it applies regardless of
// which route a locked-out member is on. Subscribes to the seat_limit_exceeded
// signal the axios interceptor emits (src/utils/auth.js) and, once it fires,
// renders the full-screen explanation in place of the app instead of letting
// every gated page underneath keep 403ing. The owner never hits this path, so
// nothing here changes for them.
export default function SeatLockGate({ children }) {
  const [lockInfo, setLockInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => subscribeSeatLocked(setLockInfo), []);

  const handleSignOut = () => {
    removeToken();
    setLockInfo(null);
    navigate("/login");
  };

  if (lockInfo) {
    return (
      <SeatLockedScreen
        currentPlan={lockInfo.current_plan}
        seatLimit={lockInfo.seat_limit}
        onSignOut={handleSignOut}
      />
    );
  }

  return children;
}
